<template>
  <div class="v-data-table v-data-table--dense theme--light">
    <div style="height: 25px;" class="text-center">
      <v-chip v-if="policyIsInForce" label small color="error">In-Force Policy</v-chip>
    </div>
    <div class="v-data-table__wrapper">
      <table style="height: 400px; overflow-y: scroll; display: block; position: relative;" class="premiumTable">
        <thead>
          <tr>
            <th style="position: sticky; top: 0; z-index: 2;" class="white">Year</th>
            <th style="position: sticky; top: 0; z-index: 2;" class="white">Age</th>
            <th style="position: sticky; top: 0; z-index: 2;" class="white">Premium</th>
            <th style="position: sticky; top: 0; z-index: 2;" class="white">Cash Value</th>
            <th style="position: sticky; top: 0; z-index: 2;" class="white">Death Benefit</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(year,yindex) in value"
            :key="'year-data-' + yindex"
          >
            <td class="px-1">
              <input
                :value="year.year"
                type="text" 
                :disabled="yindex > 0 || disabled" 
                class="policyInput"
                @input="updateYears"
              >
            </td>
            <td class="px-1">
              <input
                :value="year.age"
                type="text" 
                :disabled="yindex > 0 || disabled" 
                class="policyInput"
                @input="updateAges"
              >
              <div v-if="year.year == 1" class="policySideLabel grey--text caption">
                1035 Exchange <v-icon x-small class="grey--text">mdi-arrow-right</v-icon>
              </div>
              <div v-if="year.year <= 7" class="policySideLabel grey--text caption">
                Lump Sum <v-icon x-small class="grey--text">mdi-arrow-right</v-icon>
              </div>
            </td>
            <td class="px-1">
              <input
                :value="year.premium"
                type="text"
                class="policyInput"
                :placeholder="recentPremium(yindex)"
                @input="handleInput(yindex,'premium',$event)"
                :disabled="disabled"
              >
              <div v-if="year.year == 1">
                <input
                  :value="year['1035_exchange']"
                  type="text"
                  class="policyInput"
                  placeholder="0"
                  @input="handleInput(yindex,'1035_exchange',$event)"
                  :disabled="disabled"
                >
              </div>
              <div v-if="year.year <= 7">
                <input
                  :value="year.lump_sum"
                  type="text"
                  class="policyInput"
                  placeholder="0"
                  @input="handleInput(yindex,'lump_sum',$event)"
                  :disabled="disabled"
                >
              </div>
            </td>
            <td class="px-1">
              <input
                :value="year.cash_value"
                type="text" 
                class="policyInput"
                @input="handleInput(yindex,'cash_value',$event)"
                :disabled="disabled"
              >
            </td>
            <td class="px-1">
              <input
                :value="year.death_benefit"
                type="text" 
                class="policyInput"
                @input="handleInput(yindex,'death_benefit',$event)"
                :disabled="disabled"
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PolicyTable',
  props: ['value','disabled'],
  data () {
    return {}
  },
  watch: {
  },
  computed: {
    firstDataYear() {
      if(!this.value[0]) return null
      return this.value[0].year
    },
    firstDataAge() {
      if(!this.value[0]) return null
      return this.value[0].age
    },
    firstDataPremium() {
      if(!this.value[0]) return null
      if(this.value[0].premium == '' || this.value[0].premium === null) return null
      return parseInt(this.value[0].premium + '')
    },
    secondDataPremium() {
      if(!this.value[1]) return null
      if(this.value[1].premium == '' || this.value[1].premium === null) return null
      return parseInt(this.value[1].premium + '')
    },
    policyIsInForce() {
      return (this.firstDataYear > 1 || (this.secondDataPremium >= 0 && this.firstDataPremium >= 0 && this.secondDataPremium > this.firstDataPremium))
    },
    inforceText() {
      return ''
    }
  },
  methods: {
    handleInput (i, field, e) {
      let arr = JSON.parse(JSON.stringify(this.value))
      arr[i][field] = e.target.value
      this.$emit('input', arr)
    },
    updateYears(e) {
      let start = e.target.value
      let arr = JSON.parse(JSON.stringify(this.value))
      arr[0].year = start

      arr.forEach((d,i) => {
        if(i > 0) {
          if(start) start++
          arr[i].year = (start || '')
        }
      })
      this.$emit('input',arr)
    },
    updateAges(e) {
      let start = e.target.value
      let arr = JSON.parse(JSON.stringify(this.value))
      arr[0].age = start
      
      arr.forEach((d,i) => {
        if(i > 0) {
          if(start) start++
          arr[i].age = (start || '')
        }
      })
      this.$emit('input',arr)
    },
    recentPremium(yindex) {
      if(!yindex || yindex == '0') return ''
      for(let i = (yindex - 1); i >= 0; i--) {
        if(this.value[i].premium !== null && this.value[i].premium !== '') return this.value[i].premium
      }
      return ''
    },
  }
}
</script>

<style lang="scss" scoped>
  .darkButtonPrimary {
    ::v-deep .v-btn__content {
      ::v-deep i {
        color: #FFF !important;
      }
      color: #FFF !important;
    }
  }

  .policyButton {
    padding: unset !important;
    padding-top: 100% !important;
    height: unset !important;
    min-height: unset !important;
    max-height: unset !important;
    position: relative;
    width: 100% !important;
    ::v-deep i {
      font-size: 50px;
      margin-bottom: 5px;
    }
    ::v-deep .v-btn__content {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      flex-direction: column;
    }
  }

  .policyInput {
    margin-top:2px;
    margin-bottom: 2px;
    background-color: #FFF;
    max-width: 100%;
    width: 100%;
    padding: 2px 4px;
    border: 1px solid rgba(0,0,0,.3);
    border-radius: 2px;
    &:focus {
      outline: unset;
    }
    &:disabled {
      background-color: rgba(0,0,0,.05);
    }
  }

  .premiumTable > tbody > tr > td {
    vertical-align: top;
  }
  .policySideLabel {
    height: 27px;
    line-height: 27px;
    text-align: right;
    margin-top:2px;
    margin-bottom: 2px;
  }
</style>